/* =============================================================
   TOUR SPRAY — PDP (product page) interactions
   - Gallery thumbs
   - Variant pill selection (builds up option state, syncs hidden <select>)
   - Qty stepper
   - AJAX add-to-cart (fires cart:refresh + opens drawer if present)
   ============================================================= */
(function () {
  'use strict';

  const root = document.querySelector('.tsv2-product');
  if (!root) return;

  /* ---------- Gallery thumbs ---------- */
  const mainImg = root.querySelector('[data-ts-pdp-image]');
  const thumbs = root.querySelectorAll('[data-ts-thumb]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (!mainImg) return;
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      mainImg.style.opacity = 0;
      setTimeout(() => {
        if (src) mainImg.setAttribute('src', src);
        if (srcset) mainImg.setAttribute('srcset', srcset);
        mainImg.style.opacity = 1;
      }, 160);
    });
  });

  /* ---------- Variant selection ---------- */
  const form = root.querySelector('[data-ts-pdp-form]');
  if (!form) return;
  const select = form.querySelector('[data-ts-variant-select]');
  const atcBtn = form.querySelector('[data-ts-pdp-atc]');
  const priceEl = root.querySelector('[data-ts-price]');
  const compareEl = root.querySelector('[data-ts-compare]');
  const atcPriceEl = form.querySelector('[data-ts-atc-price]');
  const pills = form.querySelectorAll('.tsv2-product__variant-pill');

  function getCurrentOptions() {
    const groups = form.querySelectorAll('.tsv2-product__variant-group');
    return Array.from(groups).map((g) => {
      const active = g.querySelector('.tsv2-product__variant-pill.is-active');
      return active ? active.dataset.tsOptionValue : '';
    });
  }

  function findVariantByOptions(options) {
    if (!select) return null;
    const opts = Array.from(select.options);
    return opts.find((o) => {
      try {
        const vals = JSON.parse(o.dataset.options || '[]');
        return vals.length === options.length && vals.every((v, i) => v === options[i]);
      } catch (_) {
        return false;
      }
    });
  }

  function setAvailability(optionIndex, optionValue, available) {
    // Currently we only toggle disabled for exact variant matches on button click. Keeping hook for future.
  }

  function syncState() {
    const chosen = getCurrentOptions();
    const opt = findVariantByOptions(chosen);
    if (!opt) return;
    select.value = opt.value;
    const avail = opt.dataset.available === 'true';
    const price = opt.dataset.price;
    const compare = opt.dataset.compare;

    if (priceEl && price) priceEl.textContent = price;
    if (atcPriceEl && price) atcPriceEl.textContent = price;

    if (compareEl) {
      if (compare && compare !== price && compare !== '£0.00' && compare !== '$0.00') {
        compareEl.textContent = compare;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (atcBtn) {
      atcBtn.disabled = !avail;
      const label = atcBtn.querySelector('.label');
      if (label) {
        label.innerHTML = avail
          ? 'Add to bag · <span data-ts-atc-price>' + price + '</span>'
          : 'Sold out';
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', opt.value);
    window.history.replaceState({}, '', url);
  }

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const group = pill.closest('.tsv2-product__variant-group');
      if (!group) return;
      group.querySelectorAll('.tsv2-product__variant-pill').forEach((p) => {
        p.classList.remove('is-active');
        p.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-checked', 'true');
      // Update label (e.g. Size: <em>M</em>)
      const em = group.querySelector('em');
      if (em) em.textContent = pill.textContent.trim();
      syncState();
    });
  });

  /* ---------- Qty stepper ---------- */
  const qtyInput = form.querySelector('[data-ts-qty-input]');
  form.querySelectorAll('[data-ts-qty-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const step = parseInt(btn.dataset.tsQtyStep, 10) || 1;
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      qtyInput.value = next;
    });
  });

  /* ---------- AJAX ATC ---------- */
  form.addEventListener('submit', async (e) => {
    if (!atcBtn || atcBtn.disabled) return;
    e.preventDefault();
    const cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    const id = select ? select.value : form.querySelector('input[name="id"]').value;
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    const originalLabel = atcBtn.querySelector('.label').innerHTML;
    atcBtn.classList.add('is-loading');
    atcBtn.querySelector('.label').textContent = 'Adding…';

    try {
      const res = await fetch(cartUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] }),
      });
      if (!res.ok) throw new Error('cart add failed');

      atcBtn.classList.remove('is-loading');
      atcBtn.querySelector('.label').textContent = 'Added ✓';

      // Notify cart drawer (Dawn-style)
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        try {
          const data = await res.clone().json();
          drawer.renderContents(data);
        } catch (_) {}
      } else if (window.CartNotification && window.CartNotification.renderContents) {
        try {
          const data = await res.clone().json();
          window.CartNotification.renderContents(data);
        } catch (_) {}
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        atcBtn.querySelector('.label').innerHTML = originalLabel;
      }, 1800);
    } catch (err) {
      console.error('[TourSpray PDP] ATC error:', err);
      atcBtn.classList.remove('is-loading');
      atcBtn.querySelector('.label').textContent = 'Try again';
      setTimeout(() => {
        atcBtn.querySelector('.label').innerHTML = originalLabel;
      }, 1800);
    }
  });

  /* ---------- Reveal on intersection (fallback when landing JS isn't loaded) ---------- */
  const revealables = root.querySelectorAll('.tsv2-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-revealed');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealables.forEach((el) => io.observe(el));
  } else {
    revealables.forEach((el) => el.classList.add('is-revealed'));
  }
})();
